import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateExerciseMutationVariables = Types.Exact<{
  input: Types.CreateExerciseInput;
}>;


export type CreateExerciseMutation = { createExercise: { success?: boolean | null, errorCode?: Types.ResourceErrorCodeEnum | null, exercise?: { id: string } | null } };


export const CreateExerciseDocument = /*#__PURE__*/ gql`
    mutation createExercise($input: CreateExerciseInput!) {
  createExercise(data: $input) {
    success
    errorCode
    exercise {
      id
    }
  }
}
    `;

export function useCreateExerciseMutation() {
  return Urql.useMutation<CreateExerciseMutation, CreateExerciseMutationVariables>(CreateExerciseDocument);
};